<template>
    <BudgetEntries ref="budgetEntries" titleTable="Revenue" category="Revenue"/>
</template>
<script>
    const BudgetEntries = () => import('./list.vue')
    export default {
        name: 'budget-entries-revenue',
        components: {
            BudgetEntries
        },
        methods: {
            updateColumnSettings() {
                this.$refs.budgetEntries.getColumnSettings();
            }
        }
    }
</script>
